export const useQuery = (): URLSearchParams => {
  return new URLSearchParams(window.location.search);
};

export const capitalize = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1);
